define("js/format-price",[],function(){"use strict";return{stripTrailingZeros:function(r){return String(r).replace(/([,.]00)([^\d.,]+)?$/u,"$2")}}});
